import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { languages } from 'src/content/Settings/Profile/languages';
import { getKcLang, setKcLang } from 'src/keycloak';
import { getBrowsersLanguage } from 'src/utils/utils';


export const useLanguage = () => {
  const { i18n } = useTranslation();
  const [searchParam] = useSearchParams();

  const lang = searchParam.get('lang');

  const setLanguage = useCallback(
    (lang: string) => {
      setKcLang(lang);              
      i18n.changeLanguage(lang);     
    },
    [i18n]
  );

  useEffect(() => {
    if (lang) {
      setLanguage(lang);
      return;
    } 
    
    const savedLang = getKcLang();
    if (savedLang) {
      setLanguage(savedLang);
      return;
    }
    const browserLang = getBrowsersLanguage();
    setLanguage(browserLang);
  }, []);

  const currentLang =
    languages.find((lang) => lang.code === i18n.language) ?? languages[0];

  return {
    language: currentLang,
    changeLanguage: setLanguage
  };
};
